/**
 * Countries Data Provider
 * 
 * Provides cached access to country data via the Creode Ajax API.
 * Supports filtering countries by currency.
 */
class Countries {

  /**
   * Get all countries data
   * @returns {Promise<Array>} Array of country objects
   */
  async get() {
    // Return cached data if already loaded
    if (typeof this.countries != 'undefined') {
      return this.countries;
    }

    // Fetch and cache countries data from API
    this.countries = await creodeAjaxAPI.getData('countries');

    return this.countries;
  }

  /**
   * Get countries filtered by currency
   * @param {string} currency - ISO currency code to filter by (e.g., 'USD', 'EUR', 'GBP')
   * @returns {Promise<Array>} Array of country objects matching the currency
   */
  async getByCurrency(currency) {
    const countries = await this.get();

    // Filter countries by matching currency
    return countries.filter(
      (country) => {
        return country.currency === currency;
      }
    );
  }
}

// Initialize countries instance when creodeAjaxAPI is available
(async () => {
  // Wait for creodeAjaxAPI dependency to be loaded using polling mechanism
  await new Promise(
    (resolve) => {
      // Poll every 50ms to check if creodeAjaxAPI is available
      const interval = setInterval(
        () => {
          // If creodeAjaxAPI is still not defined, continue polling
          if (typeof creodeAjaxAPI == 'undefined') {
            return;
          }

          // Dependency is now available - stop polling and resolve promise
          clearInterval(interval);
          resolve();
        },
        50 // Check every 50 milliseconds
      );
    }
  );

  // Create global countries instance now that creodeAjaxAPI is ready
  window.countries = new Countries();
})();
